

import { form2fhir, fhir2form } from '../Date/Format/index.js'

import { transform } from './mapper.js'

const mapping = [
  {
    fhir: [ 'resourceType' ],
    fhir_const: 'DocumentReference'
  },
  {
    fhir: [ 'id' ],
    form: [ 'id' ]
  },
  {
    fhir: [ 'type', 'coding', 0 ],
    form: [ 'type' ]
  },
  {
    fhir: [ 'created' ],
    form: [ 'created' ],
    to_fhir: form2fhir,
    to_form: fhir2form
  },
  {
    fhir: [ 'indexed' ],
    form: [ 'indexed' ]
  },
  {
    fhir: [ 'status' ],
    fhir_const: 'current'
  },
  {
    fhir: [ 'description' ],
    form: [ 'description' ]
  },
  {
    fhir: [ 'securityLabel', 0, 'coding', 0 ],
    form: [ 'mPower' ],
    to_fhir: v => {
      const nv = {
        system: 'http://hl7.org/fhir/v3/Confidentiality',
        code: 'N',
        display: 'normal'
      }
      if (v) {
        nv.code = 'R'
        nv.display = 'restricted'
      }
      return nv
    },
    to_form: v => {
      let nv = false
      if (v.code && v.code === 'R') {
        nv = true
      }
      return nv
    }
  },
  {
    fhir: [ 'content', 0, 'attachment', 'creation' ],
    form: [ 'indexed' ]
  },
  {
    fhir: [ 'content', 0, 'attachment', 'contentType' ],
    form: [ 'attachedFileMeta', 'mime_type' ]
  },
  {
    fhir: [ 'content', 0, 'attachment', 'size' ],
    form: [ 'attachedFileMeta', 'size' ]
  },
  {
    fhir: [ 'content', 0, 'attachment', 'title' ],
    form: [ 'attachedFileMeta', 'filename' ]
  },
  {
    fhir: [ 'content', 0, 'attachment', 'hash' ],
    form: [ 'attachedFileMeta', 'id' ]
  },
  {
    fhir: [ 'content', 0, 'attachment', 'language' ],
    fhir_const: 'en'
  }
]

export function toFHIR (data, ptId) {
  const res = transform(data, mapping, [ 'form', 'fhir' ])
  const ptRef = { reference: `Patient/${ptId}` }
  res.subject = ptRef
  return res
}

export function fromFHIR (data) {
  const res = transform(data, mapping, [ 'fhir', 'form' ])
    res.updated_at = data?.meta?.lastUpdated
  return res
}
